export const FETCH_ACCOUNT_DETAILS_START = "FETCH_ACCOUNT_DETAILS_START";
export const FETCH_ACCOUNT_DETAILS_SUCCESS = "FETCH_ACCOUNT_DETAILS_SUCCESS";
export const UPDATE_PROFILE_DETAILS_START = "UPDATE_PROFILE_DETAILS_START";
export const SHOW_ACCOUNT_NOTIFICATION = "SHOW_ACCOUNT_NOTIFICATION";
export const HIDE_ACCOUNT_NOTIFICATION = "HIDE_ACCOUNT_NOTIFICATION";
export const UPDATE_PASSWORD_START = "UPDATE_PASSWORD_START";
export const EMAIL_UPDATED = "EMAIL_UPDATED";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_FAILURE = "UPDATE_PASSWORD_FAILURE";
export const UPDATE_PASSWORD_RESET_STATE = "UPDATE_PASSWORD_RESET_STATE";
export const RE_ENTER_PASSWORD_START = "RE_ENTER_PASSWORD_START";
export const RE_ENTER_PASSWORD_FAILURE = "RE_ENTER_PASSWORD_FAILURE";
export const RE_ENTER_PASSWORD_RESET_STATE = "RE_ENTER_PASSWORD_RESET_STATE";
export const UPDATE_PROFILE_DETAILS = "UPDATE_PROFILE_DETAILS";
export const CANCEL_ACCOUNT_START = "CANCEL_ACCOUNT_START";
// export const CANCEL_ACCOUNT_SUCCESS = "CANCEL_ACCOUNT_SUCCESS";
export const CANCEL_ACCOUNT_FAILURE = "CANCEL_ACCOUNT_FAILURE";
export const CANCEL_ACCOUNT_RESET_STATE = "CANCEL_ACCOUNT_RESET_STATE";
export const INITIATE_ACCOUNT_ACTIVITY_CHANGE =
  "INITIATE_ACCOUNT_ACTIVITY_CHANGE";
export const UPGRADE_PLAN_START = "UPGRADE_PLAN_START";
export const UPDATE_CREDIT_CARD_START = "UPDATE_CREDIT_CARD_START";
export const FETCH_CC_DETAILS_START = "FETCH_CC_DETAILS_START";
export const FETCH_CC_DETAILS_SUCCESS = "FETCH_CC_DETAILS_SUCCESS";
export const FETCH_BILLING_INFO_START = "FETCH_BILLING_INFO_START";
export const FETCH_BILLING_INFO_SUCCESS = "FETCH_BILLING_INFO_SUCCESS";
export const CHANGE_TO_PAID_PLAN = "CHANGE_TO_PAID_PLAN";
export const FETCH_RENEWAL_PRICE_START = "FETCH_RENEWAL_PRICE_START";
export const FETCH_RENEWAL_PRICE_SUCCESS = "FETCH_RENEWAL_PRICE_SUCCESS";
export const FETCH_UPGRADE_PROP_CHARGES_START =
  "FETCH_UPGRADE_PROP_CHARGES_START";
export const UPGRADE_PLAN_SUCCESS = "UPGRADE_PLAN_SUCCESS";
export const FETCH_UPGRADE_PROP_CHARGES_SUCCESS =
  "FETCH_UPGRADE_PROP_CHARGES_SUCCESS";
export const UPDATE_CREDIT_CARD_SUCCESS = "UPDATE_CREDIT_CARD_SUCCESS";
export const INITIATE_UPGRADE_PLAN = "INITIATE_UPGRADE_PLAN";
export const FETCH_USER_PLANS_START = "FETCH_USER_PLANS_START";
export const FETCH_USER_PLANS_SUCCESS = "FETCH_USER_PLANS_SUCCESS";
export const ACCOUNT_SETTINGS_CHANGED_PNS_START =
  "ACCOUNT_SETTINGS_CHANGED_PNS_START";
export const CANCEL_ACCOUNT_PNS_START = "CANCEL_ACCOUNT_PNS_START";
export const APPLY_PENDING_CHARGES_START = "APPLY_PENDING_CHARGES_START";
export const APPLY_PENDING_CHARGES_FAILED = "APPLY_PENDING_CHARGES_FAILED";
